import {Component, ElementRef, inject, Input, OnInit, Optional} from '@angular/core';
import {CommonModule} from "@angular/common";

import { Parent } from "@wms/app/parent";
import { WmsSplitPanelComponent } from "../wms-split-panel.component";

@Component({
  selector: '[wms-split-pane]',
  template: `<ng-content></ng-content>`,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class WmsSplitPaneComponent implements OnInit {
  @Input() limit: string = '';
  @Input() class: string = '';
  @Input() width: any = 0;
  @Input() height: any = 0;
  private _el;
  private _limit;

  constructor(@Optional() private parent?: Parent) {
    this._limit = parseInt(this.limit) || 50;
    const elementRef = inject(ElementRef);
    this._el = elementRef.nativeElement;
  }

  ngOnInit() {
    (this.parent as WmsSplitPanelComponent).addPane(this);
  }

  computeMaxReduction(isHeight: any, diff: any) {
    if (isHeight) {
      return Math.max(this._limit - this.height, diff);
    }
    return Math.max(this._limit - this.width, diff);
  };

  computeDimensions(isHeight: any) {
    var dimensions = this._el.getBoundingClientRect();
    if (isHeight) {
      this.height = dimensions.height;
    } else {
      this.width = dimensions.width;
    }
  };

  adjust(isHeight: any, diff: any) {
    if (isHeight) {
      this.height = this.height + diff;
      this._el.style.height=this.height +'px'
    } else {
      this.width = this.width + diff;
      this._el.style.width=this.width +'px'
    }
  };

}
